/**
 * Teal callout box under the activity table on each expanded check.
 * Renders the engine's correctiveAction verbatim — no UI-invented wording
 * (Data Integrity Rule). Supports both string and { tier, text, ... } shapes.
 *
 * CERT-FIX-1 Part 5 (Amendment v3.17): the Tier-2 verification instruction is
 * rendered as the closing sentence INSIDE the box — verbatim from the single
 * engine emission (verificationNote; the engine attaches null for Tier 1, so
 * Tier-1 boxes are unchanged). Identical text to the PDF box (Rule 3/12).
 */
export function CorrectiveActionBox({ action, verificationNote = null }) {
  if (!action) return null;
  const text = typeof action === 'string'
    ? action
    : (action.text || action.message || action.statement || '');
  if (!text) return null;
  const note = verificationNote
    || (typeof action === 'object' ? action.verificationNote : null)
    || null;
  return (
    <div className="action-box">
      <div className="action-title">Corrective Action</div>
      <div className="action-text">
        {text}
        {note ? ` ${note}` : ''}
      </div>
    </div>
  );
}
